import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Bell, LogOut, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Nav({ variant = "app" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const links = user
    ? [
        { to: "/dashboard", label: "Dashboard" },
        { to: "/matches", label: "Matches" },
        { to: "/shortlist", label: "Shortlist" },
        { to: "/readiness", label: "Readiness" },
        { to: "/subscription", label: "Plans" },
        ...(user.is_admin ? [{ to: "/admin/panel", label: "Automation" }, { to: "/admin/testimonials", label: "Admin" }, { to: "/admin/kyc", label: "KYC Review" }] : []),
      ]
    : [
        { to: "/how-it-works", label: "How it works" },
        { to: "/kundali", label: "Kundali × AI" },
        { to: "/family", label: "Family Circle" },
        { to: "/philosophy", label: "Philosophy" },
        { to: "/compare", label: "Compare" },
        { to: "/subscription", label: "Pricing" },
      ];

  return (
    <header
      className="sticky top-0 z-40 border-b border-stone-200"
      style={{ background: "rgba(249,248,246,0.85)", backdropFilter: "blur(16px)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="w-10 h-10 rounded-full grid place-items-center shadow-md" style={{ background: "#1E1B4B" }}>
            <span className="font-serif-display text-amber-400 text-xl leading-none">अ</span>
          </span>
          <span className="font-serif-display text-2xl sm:text-[26px] font-bold tracking-tight text-[#1E1B4B] leading-none">Anubandh<span className="text-amber-600 mx-0.5">·</span>AI</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <button key={l.to}
               onClick={() => nav(l.to)}
               data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
               className={`text-sm transition-colors ${loc.pathname === l.to ? "text-[#1E1B4B] font-medium" : "text-stone-600"} hover:text-[#1E1B4B]`}>
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <button data-testid="nav-notifications-btn" onClick={() => nav("/notifications")}
                className="p-2 rounded-full hover:bg-stone-100 text-stone-700"><Bell size={18} /></button>
              <button data-testid="nav-logout-btn" onClick={() => { logout(); nav("/"); }}
                className="hidden md:flex items-center gap-1 text-sm text-stone-600 hover:text-[#1E1B4B]">
                <LogOut size={16} /> Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn" className="hidden sm:inline text-sm text-stone-700 hover:text-[#1E1B4B]">Sign in</Link>
              <Link to="/signup" data-testid="nav-signup-btn"
                className="btn-pill text-sm text-white" style={{ background: "#1E1B4B" }}>
                Begin
              </Link>
            </>
          )}
          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-stone-200 bg-white px-6 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <button key={l.to} onClick={() => { setOpen(false); nav(l.to); }} className="text-left text-stone-700">{l.label}</button>
          ))}
          {user && <button onClick={() => { logout(); nav("/"); }} className="text-left text-stone-700">Sign out</button>}
        </div>
      )}
    </header>
  );
}
